import z from "zod";
import { AmenitySchema } from "./Amenity";
import type { Amenity } from "./Amenity";

export const RoomSchema = z.object({
  id: z.string(),
  available: z.boolean(),
  description: z.string().optional(),
  locationId: z.string(),
  name: z.string(),
  swatch: z.string(),
  floor: z.string().optional(),
  displayOrder: z.number().optional(),
  isAccessible: z.boolean().optional(),
  capacity: z.number().int().min(1).max(100).optional(),
  amenities: AmenitySchema.array().optional(),
  gallery: z.array(z.string()).optional(),
  videoTourUrl: z.string().optional(),
  shutterUntil: z.coerce.date().optional(), // Date when room closure ends (if shuttered)
  createdAt: z.string().optional(), // ISO date string
  updatedAt: z.string().optional(), // ISO date string
});

export type RoomSuggestion = {
  id: string;
  locationId: string;
  locationName?: string;
  gallery: Array<string | []>;
  name: string;
  swatch: string;
  availableFor: string;
  availableDate: Date;
  availableTime: string;
  amenities: Array<Amenity | []>;
};

export type RoomSearchCriteria = {
  locationId: string;
  isNearby?: boolean;
  date: Date;
  time: string;
  isRecurring?: boolean;
  durationInHours: number;
  isAccessible?: boolean;
  requiredAmenityIds?: string[];
  limit?: number;
};

export type Room = z.infer<typeof RoomSchema>;

export interface RoomFilters {
  // ids
  id?: string;
  locationId?: string;

  // misc
  name?: string;

  // status
  isAvailable?: boolean;
  isAccessible?: boolean;
  hasAmenities?: boolean;
  hasTypeOfAmenityId?: string;
  hasAllTypeOfAmenityIds?: string[];
  hasGalleryImages?: boolean;
  hasVideoTour?: boolean;

  searchTerm?: string;
}

export interface RoomSort {
  field: "name" | "floor" | "available" | "displayOrder";
  order: "asc" | "desc";
}
